import PropTypes from "prop-types";
import { Voicemail } from "@brivity/ai-components";
import AiProvider from "./AiProvider";

const AiVoicemail = ({ audioUrl, callSid }) => (
  <AiProvider>
    <Voicemail callSID={callSid} fallbackAudioUrl={audioUrl} />
  </AiProvider>
);

AiVoicemail.propTypes = {
  audioUrl: PropTypes.string.isRequired,
  callSid: PropTypes.string.isRequired,
};

export default AiVoicemail;
